
<template>
    <form @submit.prevent="login()" v-if="!$auth().check()">
        <div class="mb-3">
            <div class="form-floating" :class="{ 'is-invalid': error('username') }">
                <input type="text" ref="username" class="form-control rounded-3" :class="{ 'is-invalid': error('username') }" v-model="state.form.username" id="login-username" placeholder="name@example.com">
                <label for="login-username">Benutzername</label>
            </div>
            <div class="invalid-feedback" v-if="error('username')">{{ error('username') }}</div>
        </div>
        <div class="mb-3">
            <div class="form-floating" :class="{ 'is-invalid': error('password') }">
                <input type="password" class="form-control rounded-3" :class="{ 'is-invalid': error('password') }" v-model="state.form.password" id="login-password" placeholder="Passwort">
                <label for="login-password">Passwort</label>
            </div>
            <div class="invalid-feedback" v-if="error('password')">{{ error('password') }}</div>
        </div>
        <errors :errors="state.form.errors" :exclude="['username', 'password']" />
        <button class="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">Anmelden</button>
        <div v-if="props.forget"><small class="text-body-secondary">Passwort vergessen?</small></div>
        <div v-if="props.register"><small class="text-body-secondary">Du hast keinen Account? Jetzt registrieren.</small></div>
        <!-- <hr class="my-4">
        <h2 class="fs-5 fw-bold mb-3">Or use a third-party</h2>
        <button class="w-100 py-2 mb-2 btn btn-outline-secondary rounded-3" type="submit">
            <svg class="bi me-1" width="16" height="16">
                <use xlink:href="#twitter"></use>
            </svg>
            Sign up with Twitter
        </button>
        <button class="w-100 py-2 mb-2 btn btn-outline-primary rounded-3" type="submit">
            <svg class="bi me-1" width="16" height="16">
                <use xlink:href="#facebook"></use>
            </svg>
            Sign up with Facebook
        </button>
        <button class="w-100 py-2 mb-2 btn btn-outline-secondary rounded-3" type="submit">
            <svg class="bi me-1" width="16" height="16">
                <use xlink:href="#github"></use>
            </svg>
            Sign up with GitHub
                        </button> -->
    </form>
    <form @submit.prevent="logout()" v-else>
        <p class="mb-3"><strong>Hallo {{ $auth().user().firstname }}!</strong><br>
            Letzter Login: {{ (new Date($auth().user().login_latest).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })) }} Uhr</p>
        <errors :errors="state.form.errors" />
        <button class="w-100 btn btn-lg rounded-3 btn-primary" type="submit">Abmelden</button>
    </form>
</template>
<script setup>
import errors from "../../Components/Forms/Errors";
import { ref, reactive, inject, onMounted } from 'vue';
const emit = defineEmits(['loggedIn', 'loggedOut'])
const route = inject('route');
const props = defineProps({
    forget: {
        type: Boolean,
        default: true,
    },
    register: {
        type: Boolean,
        default: true,
    },
});
const username = ref(null)
let state = reactive({
    form: {
        username: "admin",
        password: "emotivo",
        errors: null
    }
})
function login() {
    axios.post(route('larativo.member.login'), state.form)
        .catch((error) => state.form.errors = _.get(error.response, "data.errors"))
        .then((data) => emit('loggedIn', data));
}
function logout() {
    axios.post(route('larativo.member.logout'))
        .catch((error) => state.form.errors = _.get(error.response, "data.errors"))
        .then((data) => emit('loggedOut', data));
}
function error(key) {
    return _.get(state.form.errors, `${key}.0`);
}
</script>
